<template>
  <div class="bpo-main-body">
    <div>
      <template>
        <el-row v-if="projectTodoList.length > 0">
          <el-col :span="12" style="margin-top:-10px; margin-bottom:5px; font-weight: bold">项目台账</el-col>
        </el-row>
        <div style="margin-bottom:15px;" v-if="projectTodoList.length > 0">
          <el-row v-for="(item, index) in projectTodoList" :key="index">
            <el-col :span="18">
              <span style="margin-left:10px;">・{{ item.dispTitle }}</span>
            </el-col>
            <el-col :span="3">
              <el-button v-if="item.popupFlg == '0'" :disabled="item.dispNum<=0" size="mini" type="text" @click="handleMsgBtnClick(item);">
                <span v-if="item.dispNum>0" style="color:red;font-weight: bold;">{{ item.dispNum }}</span>
                <span v-else>{{ item.dispNum }}</span>
              </el-button>
              <el-button v-if="item.popupFlg == '1'" size="mini" type="text" @click="handleMsgBtnClick(item);">
                <span style="text-decoration: underline;">详细</span>
              </el-button>
            </el-col>
            <el-col :span="3">
              <span>件</span>
            </el-col>
          </el-row>
        </div>
        <el-row v-if="archiveTodoList.length > 0">
          <el-col :span="12" style="margin-top:-10px; margin-bottom:5px; font-weight: bold">项目归档</el-col>
        </el-row>
        <div style="margin-bottom:15px;" v-if="archiveTodoList.length > 0">
          <el-row v-for="(item, index) in archiveTodoList" :key="index">
            <el-col :span="18">
              <span style="margin-left:10px;">・{{ item.dispTitle }}</span>
            </el-col>
            <el-col :span="3">
              <el-button v-if="item.popupFlg == '0'" :disabled="item.dispNum<=0" size="mini" type="text" @click="handleMsgBtnClick(item);">
                <span v-if="item.dispNum>0" style="color:red;font-weight: bold;">{{ item.dispNum }}</span>
                <span v-else>{{ item.dispNum }}</span>
              </el-button>
              <el-button v-if="item.popupFlg == '1'" size="mini" type="text" @click="handleMsgBtnClick(item);">
                <span style="text-decoration: underline;">详细</span>
              </el-button>
            </el-col>
            <el-col :span="3">
              <span>件</span>
            </el-col>
          </el-row>
        </div>
        <el-row v-if="projectAuditTodoList.length > 0">
          <el-col :span="12" style="margin-top:-10px; margin-bottom:5px; font-weight: bold">项目审核</el-col>
        </el-row>
        <div style="margin-bottom:15px;" v-if="projectAuditTodoList.length > 0">
          <el-row v-for="(item, index) in projectAuditTodoList" :key="index">
            <el-col :span="18">
              <span style="margin-left:10px;">・{{ item.dispTitle }}</span>
            </el-col>
            <el-col :span="3">
              <el-button v-if="item.popupFlg == '0'" :disabled="item.dispNum<=0" size="mini" type="text" @click="handleMsgBtnClick(item);">
                <span v-if="item.dispNum>0" style="color:red;font-weight: bold;">{{ item.dispNum }}</span>
                <span v-else>{{ item.dispNum }}</span>
              </el-button>
              <el-button v-if="item.popupFlg == '1'" size="mini" type="text" @click="handleMsgBtnClick(item);">
                <span style="text-decoration: underline;">详细</span>
              </el-button>
            </el-col>
            <el-col :span="3">
              <span>件</span>
            </el-col>
          </el-row>
        </div>
        <el-row v-if="projectReviewTodoList.length > 0">
          <el-col :span="12" style="margin-top:-10px; margin-bottom:5px; font-weight: bold">项目复核</el-col>
        </el-row>
        <div style="margin-bottom:15px;" v-if="projectReviewTodoList.length > 0">
          <el-row v-for="(item, index) in projectReviewTodoList" :key="index">
            <el-col :span="18">
              <span style="margin-left:10px;">・{{ item.dispTitle }}</span>
            </el-col>
            <el-col :span="3">
              <el-button v-if="item.popupFlg == '0'" :disabled="item.dispNum<=0" size="mini" type="text" @click="handleMsgBtnClick(item);">
                <span v-if="item.dispNum>0" style="color:red;font-weight: bold;">{{ item.dispNum }}</span>
                <span v-else>{{ item.dispNum }}</span>
              </el-button>
              <el-button v-if="item.popupFlg == '1'" size="mini" type="text" @click="handleMsgBtnClick(item);">
                <span style="text-decoration: underline;">详细</span>
              </el-button>
            </el-col>
            <el-col :span="3">
              <span>件</span>
            </el-col>
          </el-row>
        </div>
        <el-row v-if="projectSignTodoList.length > 0">
          <el-col :span="12" style="margin-top:-10px; margin-bottom:5px; font-weight: bold">项目签发</el-col>
        </el-row>
        <div style="margin-bottom:15px;" v-if="projectSignTodoList.length > 0">
          <el-row v-for="(item, index) in projectSignTodoList" :key="index">
            <el-col :span="18">
              <span style="margin-left:10px;">・{{ item.dispTitle }}</span>
            </el-col>
            <el-col :span="3">
              <el-button v-if="item.popupFlg == '0'" :disabled="item.dispNum<=0" size="mini" type="text" @click="handleMsgBtnClick(item);">
                <span v-if="item.dispNum>0" style="color:red;font-weight: bold;">{{ item.dispNum }}</span>
                <span v-else>{{ item.dispNum }}</span>
              </el-button>
              <el-button v-if="item.popupFlg == '1'" size="mini" type="text" @click="handleMsgBtnClick(item);">
                <span style="text-decoration: underline;">详细</span>
              </el-button>
            </el-col>
            <el-col :span="3">
              <span>件</span>
            </el-col>
          </el-row>
        </div>
        <el-row v-if="projectPrintTodoList.length > 0">
          <el-col :span="12" style="margin-top:-10px; margin-bottom:5px; font-weight: bold">项目文印</el-col>
        </el-row>
        <div style="margin-bottom:15px;" v-if="projectPrintTodoList.length > 0">
          <el-row v-for="(item, index) in projectPrintTodoList" :key="index">
            <el-col :span="18">
              <span style="margin-left:10px;">・{{ item.dispTitle }}</span>
            </el-col>
            <el-col :span="3">
              <el-button v-if="item.popupFlg == '0'" :disabled="item.dispNum<=0" size="mini" type="text" @click="handleMsgBtnClick(item);">
                <span v-if="item.dispNum>0" style="color:red;font-weight: bold;">{{ item.dispNum }}</span>
                <span v-else>{{ item.dispNum }}</span>
              </el-button>
              <el-button v-if="item.popupFlg == '1'" size="mini" type="text" @click="handleMsgBtnClick(item);">
                <span style="text-decoration: underline;">详细</span>
              </el-button>
            </el-col>
            <el-col :span="3">
              <span>件</span>
            </el-col>
          </el-row>
        </div>
        <el-row v-if="billTodoList.length > 0">
          <el-col :span="12" style="margin-top:-10px; margin-bottom:5px; font-weight: bold">发票中心</el-col>
        </el-row>
        <div style="margin-bottom:15px;" v-if="billTodoList.length > 0">
          <el-row v-for="(item, index) in billTodoList" :key="index">
            <el-col :span="18">
              <span style="margin-left:10px;">・{{ item.dispTitle }}</span>
            </el-col>
            <el-col :span="3">
              <el-button v-if="item.popupFlg == '0'" :disabled="item.dispNum<=0" size="mini" type="text" @click="handleMsgBtnClick(item);">
                <span v-if="item.dispNum>0" style="color:red;font-weight: bold;">{{ item.dispNum }}</span>
                <span v-else>{{ item.dispNum }}</span>
              </el-button>
              <el-button v-if="item.popupFlg == '1'" size="mini" type="text" @click="handleMsgBtnClick(item);">
                <span style="text-decoration: underline;">详细</span>
              </el-button>
            </el-col>
            <el-col :span="3">
              <span>件</span>
            </el-col>
          </el-row>
        </div>
        <el-row v-if="collectTodoList.length > 0">
          <el-col :span="12" style="margin-top:-10px; margin-bottom:5px; font-weight: bold">财务管理</el-col>
        </el-row>
        <div style="margin-bottom:15px;" v-if="collectTodoList.length > 0">
          <el-row v-for="(item, index) in collectTodoList" :key="index">
            <el-col :span="18">
              <span style="margin-left:10px;">・{{ item.dispTitle }}</span>
            </el-col>
            <el-col :span="3">
              <el-button v-if="item.popupFlg == '0'" :disabled="item.dispNum<=0" size="mini" type="text" @click="handleMsgBtnClick(item);">
                <span v-if="item.dispNum>0" style="color:red;font-weight: bold;">{{ item.dispNum }}</span>
                <span v-else>{{ item.dispNum }}</span>
              </el-button>
              <el-button v-if="item.popupFlg == '1'" size="mini" type="text" @click="handleMsgBtnClick(item);">
                <span style="text-decoration: underline;">详细</span>
              </el-button>
            </el-col>
            <el-col :span="3">
              <span>件</span>
            </el-col>
          </el-row>
        </div>
        <el-row v-if="otherTodoList.length > 0">
          <el-col :span="12" style="margin-top:-10px; margin-bottom:5px; font-weight: bold">其他</el-col>
        </el-row>
        <div style="margin-bottom:15px;" v-if="otherTodoList.length > 0">
          <el-row v-for="(item, index) in otherTodoList" :key="index">
            <el-col :span="18">
              <span style="margin-left:10px;">・{{ item.dispTitle }}</span>
            </el-col>
            <el-col :span="3">
              <el-button v-if="item.popupFlg == '0'" :disabled="item.dispNum<=0" size="mini" type="text" @click="handleMsgBtnClick(item);">
                <span v-if="item.dispNum>0" style="color:red;font-weight: bold;">{{ item.dispNum }}</span>
                <span v-else>{{ item.dispNum }}</span>
              </el-button>
              <el-button v-if="item.popupFlg == '1'" size="mini" type="text" @click="handleMsgBtnClick(item);">
                <span style="text-decoration: underline;">详细</span>
              </el-button>
            </el-col>
            <el-col :span="3">
              <span>件</span>
            </el-col>
          </el-row>
        </div>
      </template>
    </div>
    <div v-if="dialogVisibleReport">
      <el-dialog :close-on-click-modal="false" destroy-on-close :append-to-body="true"
                 :visible.sync="dialogVisibleReport" width="990px" title="CPA年度审计报告数">
        <template #default>
          <report-analysis-table :report-year="reportYear" @close-dialog="closeDialogReport"/>
        </template>
        <template #footer/>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import ReportAnalysisTable from '@/components/manage/portal/ReportAnalysisTable';
export default {
  name: 'ExpireInfoTrayForCustomer',
  props:['reportYear', 'todoList'],
  components: {
  	ReportAnalysisTable
  },
  data() {
    return {
      dialogVisibleReport: false,
    }
  },
  computed: {
    countAll() {
      let num = 0;
      if (this.todoList) {
        this.todoList.forEach(x => num = num + x.dispNum)
      }
      return num;
    },
    projectTodoList() {
      return this.todoList.filter(x => (x.todoType == 'project') && x.warnSwitch == 1)
    },
    archiveTodoList() {
      return this.todoList.filter(x => (x.todoType == 'project-archive') && x.warnSwitch == 1)
    },
    projectAuditTodoList() {
      return this.todoList.filter(x => x.todoType == 'project-audit')
    },
    projectReviewTodoList() {
      return this.todoList.filter(x => x.todoType == 'project-review')
    },
    projectSignTodoList() {
      return this.todoList.filter(x => x.todoType == 'project-sign')
    },
    projectPrintTodoList() {
      return this.todoList.filter(x => x.todoType == 'project-print')
    },
    billTodoList() {
      return this.todoList.filter(x => x.todoType == 'bill' && x.warnSwitch == 1)
    },
    collectTodoList() {
      return this.todoList.filter(x => x.todoType == 'collect' && x.warnSwitch == 1)
    },
    otherTodoList() {
      return this.todoList.filter(x => x.todoType == 'other' && x.warnSwitch == 1)
    }
  },
  methods: {
    async handleMsgBtnClick(row) {
      if (row.popupFlg == '0') {
        let queryObj = {}
        if (!_.isNull(row.paramList)) {
          row.paramList.forEach(x => {
            let strArr = x.split("-")
            this.$set(queryObj, strArr[0], strArr[1])
          })
        }
        if (queryObj == {}) {
          await this.$router.push({ name: 'dummy' })
          await this.$router.push({ name: row.componentNm })
        } else {
          await this.$router.push({ name: 'dummy' })
          await this.$router.push({ name: row.componentNm, query: { ...queryObj } })
        }
      } else {
        if (row.popupNm == 'popup2') {
          this.toCpaReportNumPop()
        }
      }
    },
    toCpaReportNumPop() {
      this.dialogVisibleReport = true;
    },
    closeDialogReport() {
      this.dialogVisibleReport = false;
    },
    closeDialog() {
      this.$emit("close-dialog")
    }
  }
}
</script>
<style scoped>
.el-row .el-col {
  margin-top: 6px;
}
</style>
